<template>
  <div class="team-introduct">
    <div class="card-content">
      <el-row :gutter="20" type="flex" class="el-row" v-show="nowShow == item.sort" v-for="(item, index) in memberList" :key="index">
        <el-col :span="6"  
            v-for="(showItem,index) in item.memberShowList" :key="showItem.id">
          <div
            class="card-content-item1 card-content-item"
            v-on:mouseover="showPicTxt(index)"
            v-on:mouseleave="hidePicTxt()"
          >
            <div
              class="background-pic2"
              v-bind:style="{ backgroundImage: 'url('+'\'' + showItem.image +'\''+ ')' }"
            ></div>
            <div
              class="mask2"
              :style="{ left: isShowPicTxtleft }"
              v-if="isShowPicTxt == index"
            >
              <p class="mask-title">{{ showItem.name }}</p>
              <p class="mask-subtitles">{{ showItem.job }}</p>
              <div></div>
              <p class="mask-subtitle">
                {{ showItem.description }}
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { handlePicPlusPre } from "@/util/util.js";
import axios from "axios";
export default {
  name: "adDetails",
  components: {},
  props: {},
  data() {
    return {
      id: null,
      message: {},
      isShowPicTxt: -1,
      pageNum: 1,
      pageSize: 4,
      total: 0,
      nowNumber: 0,
      memberList: [],
      memberShowList:[],
      isShowPicTxtleft: 0,
      intervalMethod:'',
      nowShow:1,
    };
  },
  watch: {},
  computed: {
   
  },
  methods: {
    handlePicPlusPre,
    showPicTxt(index) {
      this.isShowPicTxt = index;
      this.isShowPicTxtleft = 25 * index + 1 + "%";
    },
    hidePicTxt() {
      this.isShowPicTxt = -1;
    },
    // 重构成员列表
    rebUildMemberList() {
      let reBuildmemberList = [];
      let memberShowList = [];
      // 排序参数
      let sort = 1; 
      if(this.memberList){
         for (let index = 0; index < this.memberList.length; index++) {
          const element = this.memberList[index];
          memberShowList.push(element);
          if (
            ((index + 1) % 4 == 0 && index != 0) ||
            index == this.memberList.length - 1
          ) {
            let memberShowParam = {
              sort:sort,
              memberShowList
            }
            sort += 1;
            reBuildmemberList.push(memberShowParam);
            memberShowList = [];
          }
        }
        this.memberList = reBuildmemberList;
        console.log("this.memberList----2")
        console.log(this.memberList)
        // 出触发定时器
      let intervalMethod = () => {
        if (this.nowShow < this.memberList.length ) {
          this.nowShow = this.nowShow + 1;
        }else{
          this.nowShow = 1;
        }
      }
      // this.intervalMethod = intervalMethod
       this.intervalMethod = window.setInterval(intervalMethod, 5000);
      }
      // console.log("--触发--");
      // const intervalMethod = () => {
      //    console.log("--触发2--");
      //   if (this.nowNumber >= this.total) {
      //     this.nowNumber = 0;
      //     this.pageNum = 1;
      //   }
      //   this.getTeamMemberList();
      // }
      // this.intervalMethod = intervalMethod
      // window.setInterval(this.intervalMethod, 5000);
    },
    getTeamMemberList() {
      const params = {
        pageNum: this.pageNum,
        pageSize: 1000,
      };
      axios
        .get(`/api/staff/list`, {
          params,
        })
        .then((res) => {
          // console.log(res)
          if (res.data && res.data.code == 200) {
            this.memberList = res.data.rows;
            this.total = res.data.total;
            this.pageNum = this.pageNum +1;
            if (this.memberList) {
              this.nowNumber = this.nowNumber + this.memberList.length;
              this.memberList.forEach((member) => {
                if (member.image) {
                  console.log("--member--")
                  member.image = this.handlePicPlusPre(member.image);
                  member.image = member.image[0];
                }
              });
              this.rebUildMemberList();
            }
            // console.log("getAdPosition-middle")
            // console.log(this.processArray);
          }
          // console.log("getAdPosition-end")
        });
    },


  },
  created() {},
  mounted() {
    this.getTeamMemberList();
  },
  beforeDestroy() {
    console.log("destroyed--intervalMethod")
    console.log(this.intervalMethod)
    window.clearInterval(this.intervalMethod);
  },
  destroyed(){

  }
};
</script>
<style scoped>
.team-introduct {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  height: 390px;
}
.team-introduct .card-content {
  width: 1060px;
  position: absolute;
  /* height: 100%; */
  /* display: flex;
  flex-direction: row;
  justify-content: center; */
}

.card-content div .background-pic2 {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 6px;
}
.card-content .mask2 {
  transition: all 0.3s ease-in-out;
  background: #359ff8;
  opacity: 0.9;
  position: absolute;
  left: 0;
  top: 0px;
  width: 23%;
  height: 285px;
  padding: 50px 0;
  text-align: center;
  border-radius: 6px;
}
.card-content .mask-title {
  font-size: 28px;
  font-weight: 700;
  color: #222;
}

.card-content .mask-subtitles {
  font-size: 16px;
  font-weight: 700;
  padding: 10px 0;
  color: #222;
}
.card-content .card-content-item {
  height: 380px;
}
.card-content .mask-subtitle {
  font-size: 14px;
  color: #222;
  padding: 6px 15%;
  text-align: left;
}
.card-content .mask2 div {
  transition: all 0.3s ease-in-out;
  font-size: 14px;
  color: #000;
  border-bottom: 1px solid #000;
  margin: 0px 35px;
  height: 1px;
  text-align: center;
}
.el-row {
  height: 390px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/teamIntroduct.vue